



































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { dictServe, doublePrevention, institutionServer, performanceServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import ChoosePeopleMore from '@/views/teamManagementTeam/choosePeopleMore.vue';
import { TableStripe } from '@/mixins/tableStripe';
import { deepClone } from '@/util/deepClone';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {
    ChoosePeopleMore,
  },
  mixins: [TableStripe],
})
export default class PublicProp extends Vue {
  visible = false;
  title = 'title';
  formData: any = {
    // areasExpertise: '', // 擅长领域
    commandFightStaffNum: '', // 指战人数
    level: '', //	应急队伍级别
    name: '', //	队伍名称
    principal: '', //	负责人
    principalContactNumber: '', // 负责人联系电话
    remark: '', // 备注
    setUpDate: '', //	成立日期
    spaceId: '', // 空间id
    totalStaffNum: '', //	总人数
    type: '', //	应急队伍类型

    deptId: '', //	单位id
    deptName: '', // 单位name
    staffList: [], // 人员列表
    affix: '', // 附件（逗号分割，最多10个）
  };

  subSpaceByAuthOptions: any = []; // 单位
  deptType = 'chooseIt'; // 选择还是手输 单位

  ruleForm: any = {
    name: [
      { required: true, message: '请输入队伍名称', trigger: 'blur' },
      { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' },
    ],
    totalStaffNum: [
      { required: true, message: '请输入总人数' },
      { type: 'number', message: '总人数必须为数字值' },
    ],
    commandFightStaffNum: [
      { required: true, message: '请输入指战人数' },
      { type: 'number', message: '指战人数必须为数字值' },
    ],
    principalContactNumber: [{ required: true, validator: this.phoneRule }],
  };
  typeList: any = []; // 应急队伍类型
  levelList: any = [
    {
      label: '国家级',
    },
    {
      label: '省级',
    },
    {
      label: '州级',
    },
    {
      label: '地市级',
    },
    {
      label: '区县级',
    },
    {
      label: '乡镇级',
    },
    {
      label: '其他',
    },
  ]; // 应急队伍级别
  helpStaffArr: any = []; // 人员列表

  async showDialog(data: any) {
    this.fileUrlLoad = publishObjectPath.imgPathWater;
    this.headers.Authorization = localStorage.getItem('token');
    await this.getTypeList(); // 应急队伍类型 下拉数据
    await this.getSubSpaceByAuth();

    switch (data.type) {
      case 'add':
        this.title = '添加救援队';
        break;
      case 'detail':
        this.title = '队伍详情';
        await this.getData(data.data.id);
        break;
      case 'edit':
        this.title = '编辑队伍';
        await this.getData(data.data.id);
        break;
      default:
        this.title = '';
    }
    this.visible = true;
  }

  hideDialog() {
    this.visible = false;
    this.formData = {};
    this.helpStaffArr = [];
    this.fileList = [];
    this.deptType = 'chooseIt';
    this.$emit('getTableData');
    // this.$nextTick(() => {
    //   (this.$refs.form as any).clearValidate();
    // });
    (this.$refs.form as any).resetFields();
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /* 详情的接口 */
  getData(id: any) {
    doublePrevention.getSingleEmergencyContingentData(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        this.fileList = this.formData.affixList;
        this.helpStaffArr = this.formData.staffList;
        /* 人员表格数据处理 */
        this.helpStaffArr.forEach((item: any) => {
          item.id = item.staffId;
          item.name = item.staffName;
          delete item.staffId;
          delete item.staffName;
        });

        if (this.formData.deptId) {
          this.deptType = 'chooseIt';
        } else {
          this.deptType = 'inputIt';
        }
        console.log(this.formData);
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }

  /* 应急队伍类型 的下拉 */
  getTypeList() {
    dictServe.getDetailsMapByName('emergencyContingentType').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.typeList = helpArr;
      } else {
        this.$message.warning('获取应急队伍类型下拉数据失败！');
      }
    });
  }

  // 设置手机号的验证规则
  phoneRule(rule: any, value: any, callback: any) {
    if (!value) {
      callback(new Error('请输入负责人联系电话'));
    } else {
      const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
      // const phoneReg = /^1[34578]\d{9}$/
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('请输入正确的负责人联系电话'));
      }
    }
  }

  submitForm() {
    /* 处理单位上传数据 */
    if (this.deptType === 'chooseIt') {
      const arr: any = (this.$refs.orgRef as any).getCheckedNodes();
      if (!arr[0]) {
        this.formData.deptId = '';
      } else {
        this.formData.deptId = arr[0].data.id;
      }
    } else {
      this.formData.deptId = '';
    }

    this.formData.staffList = deepClone(this.helpStaffArr);
    /* 处理人员上传数据 */
    this.formData.staffList.forEach((item: any) => {
      item.staffId = item.id || '';
      item.staffName = item.name;
      delete item.id;
      delete item.name;
    });

    console.log(this.formData);

    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        if (this.title === '添加救援队') this.addEmergencyContingent();
        if (this.title === '编辑队伍') this.editEmergencyContingent();
      } else {
        return false;
      }
    });
  }

  /* 新增数据 */
  addEmergencyContingent() {
    doublePrevention
      .addEmergencyContingent({
        ...this.formData,
        spaceId: this.formData.spaceId ? this.formData.spaceId : null,
      })
      .then((res: any) => {
        console.log(res);
        if (res.code === '200') {
          this.$message.success('成功新增了一条数据！');
          this.hideDialog();
        }
      });
  }

  /* 编辑 */
  editEmergencyContingent() {
    doublePrevention.editEmergencyContingent(this.formData).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('成功编辑该条数据！');
        this.hideDialog();
      }
    });
  }

  /**
   * @desc 参与人员
   * */
  private choseSponsorRemind() {
    const shuttleBox = 'ChoosePeopleMore';
    const shuttleBoxComponent = this.$refs[shuttleBox];
    (shuttleBoxComponent as any).showDialog(this.helpStaffArr);
  }

  /**
   * @desc 人员
   * */
  getCheckDeptStaffMoreData(data: any) {
    this.helpStaffArr = data;
    console.log(data);
  }

  /**
   * 删除
   */
  delScope(data: any) {
    this.helpStaffArr.splice(data.$index, 1);
  }

  /**
   * 附件用到的
   */
  private uploadUrl: any = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
  private headers: any = {};
  private fileList: any = [];
  private dialogVisible = false;
  private fileUrlLoad: any = '';
  private pathFile: any = '';
  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
    const helpArr: any = [];
    this.fileList.forEach((item: any) => {
      if (item.response) {
        helpArr.push(item.response.data[0].id);
      } else {
        helpArr.push(item.id);
      }
    });
    this.formData.affix = helpArr.toString();
  }

  private handleExceed(files: any, fileList: any) {
    this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }

  private beforeAvatarUpload(files: any, fileList: any) {
    // 限制上传文件类型
    const suffix = files.name.substring(files.name.lastIndexOf('.') + 1);
    // console.log(suffix);
    if (suffix === 'PNG' || suffix === 'JPG' || suffix === 'JPEG' || suffix === 'BMP' || suffix === 'GIF' || suffix === 'SVG' || suffix === 'PDF' || suffix === 'TXT' || suffix === 'DOC' || suffix === 'DOCX' || suffix === 'XLSX' || suffix === 'XLS' || suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg' || suffix === 'bmp' || suffix === 'gif' || suffix === 'svg' || suffix === 'pdf' || suffix === 'txt' || suffix === 'doc' || suffix === 'docx' || suffix === 'xlsx' || suffix === 'xls') {
      return true;
    } else {
      this.$message.warning('上传格式不正确，请上传格式为：PNG,JPG,JPEG,BMP,GIF,SVG,PDF,TXT,DOC,DOCX,XLSX,XLS！');
      return false;
    }
  }

  private handlePreview(file: any) {
    // console.log(file);
    this.dialogVisible = true;
    if (file.response) {
      this.pathFile = this.fileUrlLoad + file.response.data[0].path;
    } else {
      this.pathFile = this.fileUrlLoad + file.path;
    }
  }

  private handleAvatarCardFrontSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.affix = arr.toString();
  }

  private beforeClose() {
    this.dialogVisible = false;
  }
}
